import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_SHOP_PIPELINE_ACTION_TYPE } from '../actions/shopPipeline.actions';

const initialState = null;

const shopPipelineReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_SHOP_PIPELINE_ACTION_TYPE.SET_SHOP_PIPELINE:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default shopPipelineReducer;
